export default __webpack_public_path__ + "static/media/goopter-ecommerce-automatic-printing.f76a1289.jpg";